import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import { cn } from '#/lib/utils'

type PageTransitionProps = {
  children: ReactNode
  className?: string
  duration?: number
}

// Organic fluid ease with gentle acceleration and soft landing (no sudden jolt)
const SMOOTH_FLUID_EASE = [0.4, 0.0, 0.2, 1.0] as const

export default function PageTransition({
  children,
  className,
  duration = 0.7,
}: PageTransitionProps) {
  return (
    <motion.div
      className={cn('w-full', className)}
      style={{
        willChange: 'opacity',
      }}
      initial={{ opacity: 0.6 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.6 }}
      transition={{
        duration,
        ease: SMOOTH_FLUID_EASE,
      }}
    >
      {children}
    </motion.div>
  )
}
